
// class OnlySmallsNavCards {
//   wrapper = null;

//   constructor(el) {
//     this.wrapper = $(el);

//     if (this.wrapper.length) {
//       this.init();
//     }
//   }

//   init() {

//     const onlySmallsNavBlockEl = $(".nav-card-block--only-smalls");
//     if (!onlySmallsNavBlockEl.length) {
//       return;
//     }

//     const smalls = onlySmallsNavBlockEl.find(".nav-card-block__smalls");

//     if (!smalls.length) {
//       return;
//     }
//     const firstSmalls = smalls.eq(0);
//     const childCount = firstSmalls.children().length;
//     console.log(firstSmalls);
//     console.log(childCount);

//     if (childCount % 2 === 0) {
//       firstSmalls.addClass("even");
//     } else {
//       firstSmalls.addClass("odd");
//     }

//   }
// }

// export default OnlySmallsNavCards;

class OnlySmallsNavCards {
  constructor() {
    this.init();
  }

  init() {
    // Select all nav-card-block--only-smalls elements on the page
    const onlySmallsNavBlockEls = $(".nav-card-block--only-smalls");

    // Iterate through each nav-card-block--only-smalls element
    onlySmallsNavBlockEls.each((index, element) => {
      const smalls = $(element).find(".nav-card-block__smalls");

      if (!smalls.length) {
        return;
      }

      const firstSmalls = smalls.eq(0);
      const childCount = firstSmalls.children().length;

      if (childCount % 2 === 0) {
        firstSmalls.addClass("even");
      } else {
        firstSmalls.addClass("odd");
      }
    });
  }
}

export default OnlySmallsNavCards;